export default {
  editingTitle: 'Editando menú de QR Code para {{name}}',
  creatingTitle: 'Creando menú de QR Code para {{name}}',
  creatingTitleAsset: 'Creando menú de QR Code para activo',
  name: 'Nombre*',
  level: 'Nivel',
  assetTypes: 'Tipos de activo*',
  assetPlaceLevel: 'Local asociado al activo',
  assetTypesRequired: 'Debe seleccionar al menos un tipo de activo'
}
